import { useState } from "react";
import { css } from "@emotion/react";
import copy_small from "../../../assets/icons/copy_small.svg";

import { CheckIcon, IconImg } from "./style";

interface ICopyProps {
    text: string
}
export const Copy = ({ text }: ICopyProps) => {
    const [isCopying, setIsCopying] = useState(false)

    if (isCopying) return <CheckIcon width={24} height={24}/>
    return (
        <IconImg
            src={copy_small}
            alt=""
            onClick={() => {
                navigator.clipboard.writeText(text);
                setIsCopying(true)
                setTimeout(() => {
                    setIsCopying(false)
                }, 600);
            }}
        />
    )
}